import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import config from '../config';

const BtnPhone = () => {
    return (
        <Button href={`tel:${config.phone}`} className='btn-frodo tx-frodo-dark mt-2'>
            <FontAwesomeIcon icon={faPhone} /><span className='ms-2'>{config.phone}</span>
        </Button>
    );
};

export default BtnPhone;

